import type { LocalizedText } from "@yushi-portfolio/content-schema";

export type Locale = "ja" | "en";

/** Picks the requested language, falling back to Japanese (the primary language). */
export function pickText(text: LocalizedText, locale: Locale): string;
export function pickText(text: LocalizedText | undefined, locale: Locale): string | undefined;
export function pickText(text: LocalizedText | undefined, locale: Locale): string | undefined {
  if (!text) return undefined;
  if (locale === "en" && text.en?.trim()) return text.en;
  return text.ja;
}

/** Like pickText, but treats empty strings as absent. */
export function pickNonEmpty(text: LocalizedText | undefined, locale: Locale): string | undefined {
  const value = pickText(text, locale)?.trim();
  return value ? value : undefined;
}

const LABELS = {
  medium: { ja: "素材", en: "Medium" },
  dimensions: { ja: "サイズ", en: "Dimensions" },
  duration: { ja: "時間", en: "Duration" },
  technical: { ja: "機材", en: "Technical" },
  photo: { ja: "撮影", en: "Photo" },
  works: { ja: "作品", en: "Works" },
  exhibitions: { ja: "展覧会", en: "Exhibitions" },
  installationViews: { ja: "展示記録", en: "Installation Views" },
  credits: { ja: "クレジット", en: "Credits" },
  "type.painting": { ja: "絵画", en: "Painting" },
  "type.video": { ja: "映像", en: "Video" },
  "type.media-art": { ja: "メディアアート", en: "Media Art" },
  "type.other": { ja: "その他", en: "Other" },
  "exhibition.solo": { ja: "個展", en: "Solo Exhibition" },
  "exhibition.group": { ja: "グループ展", en: "Group Exhibition" },
  "exhibition.screening": { ja: "上映", en: "Screening" },
  "exhibition.event": { ja: "イベント", en: "Event" },
  "exhibition.other": { ja: "その他", en: "Other" },
} as const satisfies Record<string, Record<Locale, string>>;

export type LabelKey = keyof typeof LABELS;

export function label(key: LabelKey, locale: Locale): string {
  return LABELS[key][locale];
}
